import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  NumberField,
  ReferenceField,
  ShowButton,
  EditButton,
  TextField,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  <TextInput label="Culture" source="culture" />,
  <TextInput label="Atmosphere" source="atmosphere" />,
  <NumberInput label="Num isolates" source="num_isolates" />,
  <NumberInput label="Temperature" source="temperature" />,
  <TextInput label="Time culture" source="time_culture" />,
  <ReferenceInput
    label="Sample"
    source="id_sample"
    resource="samples"
    reference="samples"
  >
    <SelectInput optionText="code" />
  </ReferenceInput>,
  <TextInput label="Notes" source="notes" />,
];

export const CulturesList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "code", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  >
    <Datagrid>
      <TextField label="Culture code" source="code" />
      <ReferenceField
        label="Sample"
        resource="cultures"
        source="id_sample"
        reference="samples"
        link="show"
        sortBy="samples.code"
        sortable={false}
      >
        <TextField source="code" />
      </ReferenceField>
      <DateField
        source="culture_date"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
      />
      <ReferenceField
        label="Culture Medium"
        source="id_culture_medium"
        reference="culture_media"
        link={false}
      >
        <TextField source="code" />
      </ReferenceField>
      <TextField source="atmosphere" />
      <NumberField source="num_isolates" />
      <NumberField source="temperature" />
      <TextField source="time_culture" />
      <TextField source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <TextField source="notes" />

      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
